import React from 'react';
import AceEditor from 'react-ace';

import {AnalysisMainViewItemType, MainViewComponentProps} from 'analysis-tool/ui/main-view/MainViewTypes';
import {assert} from 'Asserts';

export type ReadOnlyParameterOptimizationDatasetViewProps =
  MainViewComponentProps<AnalysisMainViewItemType.VIEW_PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION>;

export default function ReadOnlyParameterOptimizationDatasetView({
  step,
}: ReadOnlyParameterOptimizationDatasetViewProps): JSX.Element {
  assert(
    step.config != null,
    'Parameter optimization modeling step unexpectedly does not have a persisted config'
  );

  const dataDefinitionConfig = step.config.variables.find(
    (variable) => variable.name === 'dataDefinitionConfig'
  )?.value;

  return (
    <>
      {dataDefinitionConfig != null ? (
        <AceEditor
          mode="json"
          theme="github"
          enableBasicAutocompletion={true}
          value={JSON.stringify(dataDefinitionConfig, null, '\t')}
          readOnly={true}
        />
      ) : (
        <div>We currently only support showing configs for steps configured through the JSON view.</div>
      )}
    </>
  );
}
